import * as Yup from 'yup';

const validationSchema = Yup.object({
  text: Yup.string()
    .required('* Melding er påkrevd')
});

export default validationSchema;
